import { ACoreXUIModule } from '@acorex/ui';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AXFEditorService } from '../../../services/editor.service';
import { AXFSignatureEditorComponent } from './signature.editor';

@NgModule({
  declarations: [AXFSignatureEditorComponent],
  imports: [CommonModule, ACoreXUIModule],
  exports: [AXFSignatureEditorComponent],
  entryComponents: [AXFSignatureEditorComponent],
  providers: [],
})
export class AXFSignatureEditorModule {
  constructor(service: AXFEditorService) {
    service.register('SignatureEditor', AXFSignatureEditorComponent);
  }
}
